import { useTranslation } from "react-i18next"
import { X } from "@phosphor-icons/react"
import { Button } from "@/components/ui/button"
import { BetterDocPreferredCareProviderSummary } from "@/modules/patients/detail/better-doc/de/components/better-doc-preferred-care-provider/better-doc-preferred-care-provider-summary"
import type { BetterDocCareProviderSearchItem } from "@/modules/patients/detail/better-doc/de/services/betterDocCareProviderSearchQuery"

type BetterDocPreferredCareProviderValueProps = {
  careProvider: BetterDocCareProviderSearchItem
  onOpenSearch: () => void
  onRemove: () => void
}

export const BetterDocPreferredCareProviderValue = ({
  careProvider,
  onOpenSearch,
  onRemove,
}: BetterDocPreferredCareProviderValueProps) => {
  const { t } = useTranslation()

  return (
    <div
      className="border-border bg-surface hover:bg-surface-hovered relative flex min-h-12 w-full items-center justify-between rounded-xl border px-2 py-1"
      data-testid="better-doc-preferred-care-provider-selected">
      <button
        type="button"
        className="focus-visible:outline-primary-focused flex min-w-0 grow px-2 py-1 text-left after:absolute after:inset-0 after:rounded-xl focus-visible:outline-2"
        onClick={onOpenSearch}>
        <BetterDocPreferredCareProviderSummary careProvider={careProvider} />
      </button>
      <Button
        type="button"
        variant="circle"
        className="relative size-10 shrink-0"
        aria-label={t("common.button.remove")}
        data-testid="better-doc-preferred-care-provider-remove-button"
        onClick={onRemove}>
        <X />
      </Button>
    </div>
  )
}
